import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tax-rate-attachment"
export default class extends Controller {
  connect() {}

  attach() {
    this.dispatch("attach", {
      detail: {
        tax_rate_id: this.element.dataset.taxRateId,
        tax_rate_label: this.element.dataset.taxRateLabel,
      },
    });
    // Close the wrapping dialog element, if present
    const dialog = this.element.closest("dialog");
    if (dialog && typeof dialog.close === "function") {
      dialog.close();
    }
  }
}
